import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../Services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private myRoute: Router, private auth: AuthService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.auth.getUser().then(user => {
      if (user) {
        return true;
      } else {
        console.log(state.url);
        this.auth.loginRedirect(state.url).then(data => {
          console.log(data);
          return true;
        })
          .catch(err => {
            console.log(err);
            this.myRoute.navigate(["home"]);
            return false;
              });
    
      }
    })
  }

}
